import { serviceRequest } from '../service-request';
import type { ChangePasswordResult } from '../../../types/server-types/services/controllers/svc-controllers/change-password-result';

export function getProfile() {
	return serviceRequest('svc/account', null, { method: 'GET' });
}
export function hasPassword() {
	return serviceRequest('svc/account/has-password', null, { method: 'GET' });
}
export function changeEmail(email: string, password: string) {
	return serviceRequest('svc/account/email', { emailAddress: email, password: password });
}

export function changePassword(oldPassword: string, newPassword: string): Promise<ChangePasswordResult> {
	return serviceRequest('svc/account/password', { oldPassword, newPassword }, { useSubmissionToken: true });
}

export function deleteAccount(password: string) {
	return serviceRequest('svc/account', { password }, { method: 'DELETE', useSubmissionToken: true });
}
export function changeName(firstName: string, lastName: string) {
	return serviceRequest('svc/account/name', { firstName, lastName }, { useSubmissionToken: true });
}

export async function uploadAvatar(file: File) {
	const formData = new FormData();
	formData.append('_file', file);
	return serviceRequest('svc/account/avatar', formData, { useSubmissionToken: true });
}

export async function deleteAvatar() {
	return serviceRequest('svc/account/avatar', {}, { method: 'DELETE', useSubmissionToken: true });
}

export function getOrganizations() {
	return serviceRequest('svc/account/organizations', null, { method: 'GET' });
}

export function getAdminOrganizations() {
	return serviceRequest('svc/account/admin-organizations', null, { method: 'GET' });
}

export function initiateMfaSetup(password: string) {
	return serviceRequest('svc/account/mfa/initiate', { password });
}

export function sendBackupEmailVerification(password: string, backupEmail: string) {
	return serviceRequest('svc/account/mfa/send-backup-email-verification', { password, backupEmail });
}

export function verifyBackupEmailCode(backupEmail: string, code: string) {
	return serviceRequest('svc/account/mfa/verify-backup-email-code', { backupEmail, code });
}

export function validateTempOtp(secret: string, otp: string) {
	return serviceRequest('svc/account/mfa/validate-temp', { secret, otp });
}

export function enableMfa(secret: string, otp: string, token: string, backupEmail?: string) {
	return serviceRequest('svc/account/mfa/enable', { secret, otp, backupEmail }, { csrfToken: token });
}

export function disableMfa(password: string) {
	return serviceRequest('svc/account/mfa/disable', { password });
}

export function changeMfaSettings(password: string, secret: boolean, otp: string, backupEmail?: string) {
	return serviceRequest('svc/account/mfa/change-settings', { password, secret, otp, backupEmail });
}

export function changeColorScheme(colorScheme: string) {
	return serviceRequest('svc/account/color-scheme', { colorScheme }, { useSubmissionToken: true });
}